import * as React from 'react';
import { FormState } from 'final-form';
import { useFormState } from 'react-final-form';

interface Props {
	formRef?: React.RefObject<HTMLFormElement>;
	children: (state: FormState<object>, formRef?: React.RefObject<HTMLFormElement>) => React.ReactElement;
}

const FormStateWrapper: React.FC<Props> = ({ formRef, children }) => {
	const state = useFormState<object>();

	return children(state, formRef);
};

export default FormStateWrapper;
